module.exports = __webpack_public_path__ + "img/126.beaf92bc.jpg";